export const GlobalStylesQuantityButtonsVariantList = [
  "quantityButtonsWidgetClassic",
  "quantityButtonsWidgetCompact",
  "quantityButtonsWidgetImage",
] as const;

export const GlobalStylesProgressBarVariantList = [
  "progressBar1",
  "progressBar2",
  "progressBar3",
] as const;

export const GlobalStylesMessageBoxVariantList = [
  "messageBoxPopupWidget1",
  "messageBoxSlideOutWidget1",
];
